import { render, staticRenderFns } from "./collectionShort.vue?vue&type=template&id=dd936780&scoped=true"
import script from "./collectionShort.vue?vue&type=script&lang=js"
export * from "./collectionShort.vue?vue&type=script&lang=js"
import style0 from "./collectionShort.vue?vue&type=style&index=0&id=dd936780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd936780",
  null
  
)

export default component.exports